import { CONTACT_FORM_HTML } from './contact-form';
import { NAV_HTML, HERO_HTML, CHAT_BUTTON_HTML, SVCS_HTML, CLIENTS_HTML, ORG_LOGOS, ORG_HEADER_HTML } from './content';
import path from 'path';

// LOADERS
document.addEventListener('DOMContentLoaded', () => {
    renderHero();
    renderSvcs();
    renderClients();
    renderContactForm();
    renderNav();
    renderLogos();
    renderOrgs();
    renderBtnChat();
});
// document.getElementById("contact-form").addEventListener("submit", (event) => {
//     const contactForm = event.target
//     // validateContactForm(contactForm) || event.preventDefault();
// });

// VALIDATION
// function validateContactForm(form) {
//     const names = form.querySelector('input[type="text"]').value;
//     const email = form.querySelector('input[type="email"]').value;
//     const phone = form.querySelector('input[type="tel"]').value;
//     const nameRegex = /[a-zA-Z][a-zA-Z\s]+$/;
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     const phoneRegex = /^\+?[0-9\s\-()]{7,}$/;
//     let errorMessage = [];
//     nameRegex.test(names[0]) || (errorMessage.push('First name must contain only letters and spaces.'));
//     nameRegex.test(names[1]) || (errorMessage.push('Last name must contain only letters and spaces.'));
//     emailRegex.test(email) || (errorMessage.push('Email must be in a valid format.'));
//     if (phone !== '' && !phoneRegex.test(phone)) {
//         errorMessage.push('Phone number must be in a valid format.');
//     }
//     if (errorMessage) {
//         console.log(errorMessage);
//         displayError(form, errorMessage);
//         return false;
//     }
//     return true;

// function displayError(form, message) {
//     let errorDiv = form.querySelector('.error-message');
//     if (!errorDiv) {
//         errorDiv = document.createElement('div');
//         errorDiv.classList.add('error-message', 'text-red-500', 'text-sm', 'mt-2');
//         for (err in message) {
//             const paragraph = document.createElement('p');
//             paragraph.textContent = err;
//             errorDiv.appendChild(paragraph);
//             console.log(errorDiv);
//         }
//         form.appendChild(errorDiv);
//     }
// }

// RENDERING HTML
function renderSvcs() {
    const svcs = document.getElementById("services");
    svcs.innerHTML = SVCS_HTML;
}
function renderOrgs() {
    const orgs = document.getElementById("orgs");
    orgs.innerHTML = ORG_HEADER_HTML;
    orgs.classList.add("mx-auto", "max-w-7xl", "py-16", "sm:py-16", "px-6", "lg:px-8");
    const logosContainer = document.createElement("div");
    logosContainer.classList.add("flex", "flex-wrap", "justify-center", "gap-12");
    for (const file of ORG_LOGOS) {
        const orgLogo = document.createElement("img");
        orgLogo.classList.add("org", "h-32", "w-auto");
        orgLogo.src = file;
        logosContainer.appendChild(orgLogo);
    }
    orgs.appendChild(logosContainer);
}
function renderClients() {
    const clients = document.getElementById("clients");
    clients.innerHTML = CLIENTS_HTML;
    clients.classList.add("bg-community-pattern", "bg-dr-overlay-light", "bg-blend-soft-light", "bg-cover", "bg-center", "py-16", "sm:py-32");
}
function renderContactForm() {
    const contact = document.getElementById("contact");
    contact.classList.add("bg-white");
    contact.innerHTML = CONTACT_FORM_HTML
}
function renderBtnChat() {
    const btnChat = document.getElementById("btnChat");
    btnChat.innerHTML = CHAT_BUTTON_HTML;
}
function renderHero() {
    const hero = document.getElementById("hero");
    hero.innerHTML = HERO_HTML;
}
function renderNav() {
    const nav = document.getElementById("nav");
    nav.innerHTML = NAV_HTML;
}
function renderLogos() {
    var logoDivs = document.getElementsByClassName("logoPlaceholder");
    for (var i = 0; i < logoDivs.length; i++) {
        const logo = document.createElement("img");
        logo.classList.add("logo");
        if (logoDivs[i].classList.contains("lg")) {
            logo.classList.add("h-20", "w-auto");
        } else {
            logo.classList.add("h-12", "w-auto");
        }
        logo.src = new URL("../static/placeholder_logo.png", import.meta.url);
        logoDivs[i].innerHTML = ""; // Clear existing content
        logoDivs[i].appendChild(logo); // Add the image to the div
    }
}
function renderSocials() {
    var divs = document.getElementsByClassName("socialPlaceholder");
    for (var i = 0; i < divs.length; i++) {
        const icon = document.createElement("img");
        icon.classList.add("icon");
        if (divs[i].classList.contains("lg")) {
            icon.classList.add("h-20", "w-auto");
        } else {
            icon.classList.add("h-12", "w-auto");
        }
        icon.src = new URL("../static/ico_linkedin.png", import.meta.url);
        divs[i].innerHTML = ""; // Clear existing content
        divs[i].appendChild(icon); // Add the image to the div
    }
}